module.exports = __webpack_public_path__ + "static/img/service-02.a46a6272.png";